import { render } from "./FullPageLoader.vue?vue&type=template&id=ae67f2ba"
import script from "./FullPageLoader.vue?vue&type=script&lang=js"
export * from "./FullPageLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__